import React, { useState } from 'react'
import {
    Button,
    Table,
    Tr,
    Flex,
    PageWrapper,
    PageFooter,
    Th,
    H1WithBack,
} from '../../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Pagination } from 'components/Pagination/Pagination'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { Options } from 'components/Options/Options'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { ModalTypes } from 'types/global.interface'
import { clearFoodInventoryItems, deleteFoodInventoryItem, getFoodInventoryItems } from 'features/food/foodSlice'
import { AddFoodItemModal, IAddFoodItemModalState } from './AddFoodItemModal'
import { IFoodInventoyItemSingleResponse } from 'types/api/foodApi.interface'

export const FoodItems: React.FC = () => {
    const { data, totalPages } = useSelector((store: RootState) => store.food.items)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState({ open: false, values: null })

    useQueryPagination({ fetchFunctions: [getFoodInventoryItems], cleanUpFunctions: [clearFoodInventoryItems], params })

    const removeItem = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFoodInventoryItem(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: data.length < 2,
                },
                word: 'delete food item',
            }),
        )
    }

    const getModalValues = (item: IFoodInventoyItemSingleResponse): IAddFoodItemModalState => {
        const values: IAddFoodItemModalState = {
            ...item,
            category: item.category ? { value: item.category.id, label: item.category.name } : null,
            ingredient: item.ingredient ? { value: item.ingredient.id, label: item.ingredient.name } : null,
            amount: item.remainingAmount,
        }
        return values
    }

    return (
        <>
            <NavBar setParams={setParams} />
            <PageWrapper>
                <Flex between center  >
                    <H1WithBack title='Food Items' arrow />
                    <Button orange onClick={() => setModal({ open: true, values: null })}>
                        Add Item
                    </Button>
                </Flex>
                {!data?.length ? (
                    <NoItems marginTop='1rem' title='Food Inventory Items' />
                ) : (
                    <Table>
                        <Th>
                            <Td w='19%' noTooltip text='NAME' />
                            <Td w='19%' noTooltip text='CATEGORY' />
                            <Td w='19%' noTooltip text='INGREDIENT' />
                            <Td w='19%' noTooltip text='REMAINING AMOUNT' />
                            <Td w='19%' noTooltip text='PRICE' />
                            <Td w='5%' />
                        </Th>
                        {data &&
                            data.map((item) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td w='19%' text={item.name} />
                                        <Td w='19%' text={item?.category?.name || '/'} />
                                        <Td w='19%' text={item?.ingredient?.name || '/'} />
                                        <Td w='19%' text={item?.remainingAmount} />
                                        <Td w='19%' text={item?.price} />
                                        <Td w='5%' options >
                                            <Options item={item} title='Food Item'
                                                openModal={() => setModal({ open: true, values: getModalValues(item) })}
                                                handleRemove={() => removeItem(item.id)}
                                            />
                                        </Td>
                                    </Tr>
                                )
                            })}
                    </Table>
                )}
                {modal.open && <AddFoodItemModal closeModal={() => setModal({ open: false, values: null })} values={modal.values} />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
